/** Illustrative relative placement only, not coordinates or a GIS contract. */
export const eventPositions: Readonly<Record<string, readonly [number, number]>> = {
  'demo-01': [44, 56],
  'demo-02': [32, 72],
  'demo-03': [33, 38],
  'demo-04': [72, 36],
  'demo-05': [79, 53],
};
export const mapLayers = [
  { id: 'event', label: '事件', symbol: '▲' },
  { id: 'warning', label: '预警信息', symbol: '◆' },
  { id: 'station', label: '消防站点', symbol: '▥' },
  { id: 'risk', label: '风险点位', symbol: '●' },
  { id: 'tree', label: '自然资源', symbol: '♧' },
] as const;
export type MapLayer = (typeof mapLayers)[number]['id'];
export const mapPlaces = [
  { name: '北部片区', x: 29, y: 22 },
  { name: '西部片区', x: 23, y: 49 },
  { name: '主城区', x: 38, y: 46 },
  { name: '梁港区', x: 32, y: 79 },
  { name: '南部片区', x: 52, y: 89 },
  { name: '东部片区', x: 72, y: 43 },
  { name: '沿海片区', x: 79, y: 27 },
  { name: '工业片区', x: 63, y: 75 },
] as const;
export const mapPoints: readonly {
  id: string;
  name: string;
  layer: Exclude<MapLayer, 'event'>;
  x: number;
  y: number;
}[] = [
  { id: 'point-01', name: '北部片区风险点位（示例）', layer: 'risk', x: 21, y: 17 },
  { id: 'point-02', name: '北部片区消防站点（示例）', layer: 'station', x: 26, y: 30 },
  { id: 'point-03', name: '主城区风险点位（示例）', layer: 'risk', x: 45, y: 33 },
  { id: 'point-04', name: '工业片区自然资源（示例）', layer: 'tree', x: 62, y: 62 },
  { id: 'point-05', name: '东部片区消防站点（示例）', layer: 'station', x: 78, y: 48 },
  { id: 'point-06', name: '工业片区预警标记（示例）', layer: 'warning', x: 55, y: 78 },
  { id: 'point-07', name: '梁港区消防站点（示例）', layer: 'station', x: 36, y: 70 },
  { id: 'point-08', name: '西部片区消防站点（示例）', layer: 'station', x: 22, y: 75 },
  { id: 'point-09', name: '西部片区自然资源（示例）', layer: 'tree', x: 17, y: 38 },
  { id: 'point-10', name: '南部片区消防站点（示例）', layer: 'station', x: 43, y: 89 },
  { id: 'point-11', name: '沿海片区自然资源（示例）', layer: 'tree', x: 86, y: 15 },
  { id: 'point-12', name: '沿海片区风险点位（示例）', layer: 'risk', x: 81, y: 38 },
];
